//angular imports
import { 
  ChangeDetectionStrategy,
  Component, 
  EventEmitter,
  Output,
  TemplateRef, 
  input 
} from '@angular/core';

//local imports
import { Transforms, IListItem } from '@app/shared';


@Component({
    selector: 'item-small-generic',
    templateUrl: './item-small-generic.component.html',
    styleUrl: './item-small-generic.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ItemSmallGenericComponent {      
  public currentItem = input<IListItem>(null);
  public isSelectable = input(false, {
    transform: Transforms.toBoolean
  });
  
  public template? = input<TemplateRef<any>>(null);
}

